const PLATFORM = 'runninghub-h3'
const MODEL = 'h3'
const DEFAULT_SECONDS = '12'
const DEFAULT_SIZE = '16:9'
const SIZES = ['16:9', '9:16', '1:1', '2:3', '3:2', '3:4', '4:3', '21:9']
const LIMITS = Object.freeze({ images: 9, videos: 1, audios: 3 })

const isH3Platform = platform => platform === PLATFORM
const isValidSeconds = value => /^\d+$/.test(String(value)) && Number.isInteger(Number(value)) && Number(value) > 0 && Number(value) <= 2147483647

const isPublicUrl = value => {
  try {
    const url = new URL(String(value || '').trim())
    return ['http:', 'https:'].includes(url.protocol) && !!url.hostname && !url.username && !url.password
  } catch (_) { return false }
}

const getReferenceError = (platform, references = {}) => {
  if (!isH3Platform(platform)) return ''
  for (const [category, label] of [['images', '图片'], ['videos', '视频'], ['audios', '音频']]) {
    const items = references?.[category] || []
    if (items.length > LIMITS[category]) return `H3 最多支持 ${LIMITS[category]} 个参考${label}`
    if (items.some(item => !item.file && !isPublicUrl(item.url))) {
      return 'H3 参考素材需要可下载的 HTTP(S) 地址，请重新选择或上传素材'
    }
  }
  return ''
}

module.exports = { PLATFORM, MODEL, DEFAULT_SECONDS, DEFAULT_SIZE, SIZES, LIMITS, isH3Platform, isValidSeconds, getReferenceError }
